import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { EditorModule } from '@tinymce/tinymce-angular';
import { CoreLibModule } from 'core-lib';
import { DateTimeNativeHtml5PickerModule, GroupPickerModule, MediaLibraryLibModule } from 'core-ui';
import { FilestoreModule } from 'filestore-lib';
import { ColorTwitterModule } from 'ngx-color/twitter';
import { PaymentLibModule } from 'payment-lib';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { AppointmentBookingConfirmationComponent } from './appointment-management/appointment-booking-confirmation/appointment-booking-confirmation.component';
import { AppointmentConfigurationComponent } from './appointment-management/appointment-configuration/appointment-configuration.component';
import { AppointmentFilterSettingsComponent } from './appointment-management/appointment-filter-settings/appointment-filter-settings.component';
import { AppointmentManagementEditComponent } from './appointment-management/appointment-management-edit/appointment-management-edit.component';
import { AppointmentManagementListComponent } from './appointment-management/appointment-management-list/appointment-management-list.component';
import { AppointmentRegistrationFormComponent } from './appointment-management/appointment-registration-form/appointment-registration-form.component';
import { AttendeesExportForm } from './appointment-management/attendees-export-form/attendees-export-form.component';
import { EventParticipantsOverviewComponent } from './appointment-management/event-participants-overview/event-participants-overview.component';
import { EventRegistrationComponent } from './appointment-management/event-registration/event-registration.component';
import { EventSignUpsOverviewComponent } from './appointment-management/event-sign-ups-overview/event-sign-ups-overview.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { EventFeedbackOverviewComponent } from './appointment-management/event-feedback-overview/event-feedback-overview.component';
import { TextareaModule } from 'primeng/textarea';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { CdkDropList } from "@angular/cdk/drag-drop";
import { AvatarModule } from 'primeng/avatar';
@NgModule({
  declarations: [
    AppointmentManagementListComponent,
    AppointmentManagementEditComponent,
    AppointmentConfigurationComponent,
    AppointmentRegistrationFormComponent,
    AppointmentBookingConfirmationComponent,
    EventRegistrationComponent,
    EventSignUpsOverviewComponent,
    AppointmentFilterSettingsComponent,
    EventParticipantsOverviewComponent,
    AttendeesExportForm,
    EventFeedbackOverviewComponent
  ],
  imports: [
    TableModule,
    ButtonModule,
    InputTextModule,
    AutoCompleteModule,
    TextareaModule,
    ProgressSpinnerModule,
    CommonModule,
    ToggleButtonModule,
    ReactiveFormsModule,
    ListboxModule,
    MediaLibraryLibModule,
    DropdownModule,
    CheckboxModule,
    CardModule,
    DialogModule,
    InputNumberModule,
    RadioButtonModule,
    AccordionModule,
    AvatarModule,
    InputGroupModule,
    InputGroupAddonModule,
    ColorPickerModule,
    PanelModule,
    DatePickerModule,
    ToolbarModule,
    SplitButtonModule,
    FormsModule,
    ImageModule,
    TagModule,
    PaginatorModule,
    BadgeModule,
    CoreLibModule,
    RouterModule,
    FullCalendarModule,
    MessageModule,
    ToastModule,
    ConfirmDialogModule,
    ColorTwitterModule,
    MultiSelectModule,
    SelectModule,
    DividerModule,
    SelectButtonModule,
    FileUploadModule,
    ChipsModule,
    MenuModule,
    GroupPickerModule,
    EditorModule,
    DateTimeNativeHtml5PickerModule,
    PaymentLibModule,
    CarouselModule,
    FilestoreModule,
    TabMenuModule,
    CdkDropList
],
  exports: [
    AppointmentManagementListComponent,
    AppointmentManagementEditComponent
  ],
  providers: [
    ConfirmationService,
    DialogService, DatePipe]
})
export class AppointmentModuleLibModule { }
